var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"small":"","color":_vm.getIconColor}},[_vm._v(" "+_vm._s(_vm.getIcon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }